import { isMobileDevice } from "src/components/WidgetMaker/WidgetDnD/isMobileDevice";
import ProductImage from "../Component/ProductImage";
import ProductText from "../Component/ProductText";
import { PRODUCT_CONTENT_POSITION } from "../constant";

function Layout2(props) {
  const { childComp, cardFrameConfig } = props
  const isProductContentLeft = cardFrameConfig?.productPosition === PRODUCT_CONTENT_POSITION.LEFT;
  const isMobile = isMobileDevice();
  
  function separatorComp() {
    return <div className="tw-w-[100%] tw-h-[1px] tw-bg-[#111C36] tw-opacity-20"></div>
  }
  
  function renderLayout2() {
    return (
      <>
        <div className={`tw-flex  ${isMobile ? 'tw-flex-col tw-gap-[16px]' : 'tw-items-center tw-gap-[24px]'} ${!isProductContentLeft ? 'tw-flex-row-reverse' : ''}`}>
          <div className={`tw-max-w-[450px]`}>
          {<ProductImage {...props} />}
          </div>
          <div className={`tw-flex tw-flex-col ${!isMobile ? 'tw-w-[50%] tw-gap-[20px]' : 'tw-gap-[16px]'}`}>
            <div >{<ProductText {...props} />}</div>
            {isMobile && <div className="tw-w-[100%]" >{separatorComp()}</div>}
            {childComp()}
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      {renderLayout2()}
    </>
  )
}

export default Layout2;